import { createSlice } from "@reduxjs/toolkit";
import { getAllArtistRewardsThunk } from './thunk';


export const initialState = {
    rewardsList: [],
    error: {},
    isLoading:false,
};

const RewardsSlice = createSlice({
    name: 'RewardsSlice',
    initialState,
    reducer: {},
    extraReducers: (builder) => {

          //get all categories
        builder.addCase(getAllArtistRewardsThunk.pending, (state, action) => {
             state.isLoading = true;
        });

          builder.addCase(getAllArtistRewardsThunk.fulfilled, (state, action) => { 
                state.rewardsList = action.payload.data;
                state.isLoading = false
        });

        builder.addCase(getAllArtistRewardsThunk.rejected, (state, action) => {
            state.error = action.payload.success || null;
            state.isLoading = false;
        });
             
    }
});

export default RewardsSlice.reducer;